// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.13.0",
  date: "2026-10-19T10:26:25.998Z",
  gitInfo: {
    dirty: false,
    raw: "cad5696ec",
    hash: "cad5696ec",
    distance: null,
    tag: null,
    semver: null,
    suffix: "cad5696ec",
    semverString: null
  }
};
/* tslint:enable */
